import { SpearfishingCampaignFragment } from '@scheduling/graphql/fragments/spearfishing-campaign';
import { gql, TypedDocumentNode } from '@common/hooks';

import {
  PaginatedSpearfishingCampaignsQueryCgResponse,
  PaginatedSpearfishingCampaignsQueryVariables,
  SpearfishableGroupsByShiftGapQueryCgResponse,
  SpearfishableGroupsByShiftGapQueryVariables,
  SpearfishableWorkersByShiftGapQueryCgResponse,
  SpearfishableWorkersByShiftGapQueryVariables,
  SpearfishingCampaignQueryCgResponse,
  SpearfishingCampaignQueryVariables,
} from '@common/graphql/schema';

export const SPEARFISHABLE_WORKERS_BY_SHIFT_GAP: TypedDocumentNode<
  SpearfishableWorkersByShiftGapQueryCgResponse,
  SpearfishableWorkersByShiftGapQueryVariables
> = gql`
  query SpearfishableWorkersByShiftGap(
    $shiftGapId: ID!
    $filters: SpearfishableWorkerFilter
  ) {
    spearfishableWorkersByShiftGap(shiftGapId: $shiftGapId, filters: $filters) {
      worker {
        id
        worksUser {
          id
          name
        }
        workforceGroup {
          id
          name
        }
      }
      spearfishable
      spearfishingDetail
    }
  }
`;

export const SPEARFISHABLE_GROUPS_BY_SHIFT_GAP: TypedDocumentNode<
  SpearfishableGroupsByShiftGapQueryCgResponse,
  SpearfishableGroupsByShiftGapQueryVariables
> = gql`
  query SpearfishableGroupsByShiftGap($shiftGapId: ID!) {
    spearfishableGroupsByShiftGap(shiftGapId: $shiftGapId) {
      id
      name
      custom
      count
      spearfishable
    }
  }
`;

export const PAGINATED_SPEARFISHING_MESSAGES: TypedDocumentNode<
  PaginatedSpearfishingCampaignsQueryCgResponse,
  PaginatedSpearfishingCampaignsQueryVariables
> = gql`
  query PaginatedSpearfishingCampaigns(
    $filters: SpearfishingCampaignFilterInput
    $limit: Int!
    $offset: Int!
    $orderDirection: OrderDirection
    $orderField: SpearfishingCampaignOrderField
  ) {
    paginatedSpearfishingCampaigns(
      filters: $filters
      limit: $limit
      offset: $offset
      orderDirection: $orderDirection
      orderField: $orderField
    ) {
      spearfishingCampaigns {
        ...SpearfishingCampaign
      }
      totalCount
    }
  }
  ${SpearfishingCampaignFragment}
`;

export const SPEARFISHING_CAMPAIGN: TypedDocumentNode<
  SpearfishingCampaignQueryCgResponse,
  SpearfishingCampaignQueryVariables
> = gql`
  query SpearfishingCampaign($id: ID!) {
    spearfishingCampaign(id: $id) {
      campaign {
        ...SpearfishingCampaign
        message
        spearfishingNotifications {
          id
          state
          targetWorksMembership {
            id
            worksUser {
              id
              name
            }
          }
          targetWorker {
            id
          }
        }
      }
      workforceGroups {
        id
        name
      }
    }
  }
  ${SpearfishingCampaignFragment}
`;
